import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import * as DOMPurify from 'dompurify';
import PaymentDataContainer from "../../Stores/PaymentDataContainerStore";

import { PaymentMethodsContainer, PaymentInput } from "./";
import { Dropdown, Button, ButtonGroup } from "react-bootstrap";
import { myGlobals, myUtilities } from "../../Utils";
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";

class PaymentElements extends React.Component {
  constructor(props) {
    super(props);
    this.paymentData = null;
    this.displayNameVsValueMap = {};
    this.populateEIPPDropdownItems = this.populateEIPPDropdownItems.bind(this);
    this.setPaymentDataToState = this.setPaymentDataToState.bind(this);
    this.populateDisplayNameVsValueMap = this.populateDisplayNameVsValueMap.bind(this);
    this.state = {
      eippDropdownValues: [],
      isDropdownStoreLoaded: false,
      currentValueInEIPPDropdown: ""
    };
  }

  renderBody = () => {
    if (this.props.isMandateField && this.props.isEIPPDropdown) {
      return;
    }
    if (this.props.paymentMethodSelection) {
      return <PaymentMethodsContainer />;
    } else
      return (
        <PaymentInput
          name={this.props.name}
          isNumber={this.props.isNumber === "true"}
          EUR={DOMPurify.sanitize(this.props.EUR)}
          isMandateField={this.props.isMandateField}
          isRequiredField={this.props.isRequiredField}
          customValidationRegex={this.props.customValidationRegex}
          customValidationMessage={this.props.customValidationMessage}
          customValidationMessageMLKey={this.props.customValidationMessageMLKey}
        />
      );
  };
  handleChange = (eventVal, data) => {
	    let val = eventVal;
	    data.populateInputData(this.props.name2, val);
	  };
  decideDropDownToShow = (data) => {
    // console.log(this.props);
    if (this.props.isEIPPDropdown) {
      return this.getEIPPDropDown(data);
    }

    if (this.props.accountType) {
    	return this.genDropdownAccountType(data);
    } else  return this.genDropdownCountryCode(data);
  };

  handleChangeForEIPPDropdown = (eventVal, data) => {
    let val = eventVal;
    // console.log("val selected -> ", val);
    let achMandateFields = data.state.achMandateFields;
    
    console.log("val before change -> " + val);
    let value = this.displayNameVsValueMap[val];
    console.log("val after change -> " + value);
    
    if (this.props.isMandateField) {
        console.log("value in achMandateField -> " + value);
        if (value.length > 0 && null != achMandateFields) {
          achMandateFields[this.props.name] = value;
          data.setACHMandateFields(achMandateFields);
        } else if (value.length > 0 && null == achMandateFields) {
          achMandateFields = {};
          achMandateFields[this.props.name] = value;
          data.setACHMandateFields(achMandateFields);
        }
        
        // for display on UI, display Name will be used
        // displayName is stored in val
        // displayValue is stored in value
        this.setState({
          currentValueInEIPPDropdown: val
        });
  	}
  };

  getEIPPDropDown = (paymentData) => {
    let dropdownToggleId = "dropdown-split-" + this.props.name;
    // splitting dropdownToggleId by space and joining by hyphen, used later in trifectaTheme.css for custom CSS
    // CSS property -> #dropdown-split-Account-Holder-Type:empty::after
    // If you change this, make sure to add entry in trifectaTheme.css as well
    dropdownToggleId = dropdownToggleId.trim().split(" ").join("-");
    return (
      <Dropdown
        onSelect={(evt) => this.handleChangeForEIPPDropdown(evt, paymentData)}
        className={"country-dropdown"}
        as={ButtonGroup}
      >
        <Button 
          variant="success" 
          name={this.props.name}
        >
          <span>
            {myUtilities.accountSpecificLanguage(
              "ACHForm." + this.state.currentValueInEIPPDropdown,
              this.state.currentValueInEIPPDropdown
            )}
          </span>
        </Button>

        <Dropdown.Toggle
          split
          variant="success"
          id={dropdownToggleId}
        />

        <Dropdown.Menu>
          {this.state.eippDropdownValues}
        </Dropdown.Menu>
      </Dropdown>
    );
  };

  populateEIPPDropdownItems = async () => {
    let options = [];
    let dropdownValue = "";
    let link = "getBankTransferFieldsDropdownValues";
    link = myGlobals.initialHost + myGlobals.appender + link;
    const searchParams = new URLSearchParams();
    console.log("dropdownStoreName -> ", this.props.dropdownStoreName);
    searchParams.append('token', myGlobals.token);
    searchParams.append("dropdownStoreName", this.props.dropdownStoreName);

    await fetch(link, {
      method: "POST",
      body: searchParams,
    })
    .then((response) => {
      if (response.status !== 200) {
        console.log("Looks like there was a problem. Status Code: " + response.status);
        return;
      }
      return response.json();
    })
    .then((data) => {
      data.rows.forEach((dropdown) => {
        var sanitizeddropdown = DOMPurify.sanitize(dropdown.displayName);
        this.populateDisplayNameVsValueMap(dropdown);
        if (dropdownValue == "") {
          dropdownValue = sanitizeddropdown;
        }
        options.push(
          <Dropdown.Item
            key={sanitizeddropdown}
            eventKey={sanitizeddropdown}
          >
            {myUtilities.accountSpecificLanguage(
              "ACHForm." + sanitizeddropdown,
              sanitizeddropdown
            )}
          </Dropdown.Item>
        );
      });

      console.log("displayNameVsValueMap -> " + this.displayNameVsValueMap);

      this.setState({
        eippDropdownValues: options,
        isDropdownStoreLoaded: true,
        currentValueInEIPPDropdown: dropdownValue
      });
    })
    .catch(function (err) {
      console.log("Fetch Error :-S", err);
    });
  };

  populateDisplayNameVsValueMap = (dropdown) => {
    // global map of display name vs display value
    this.displayNameVsValueMap[dropdown.displayName] = dropdown.value;
  };

  genDropdownCountryCode = (paymentData) => {

    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(invdata) => {
          if (paymentData.state.countryCode === "")
            paymentData.setState({
              countryCode: invdata.state.defaultCountryCode,
            });
          return (
            <Dropdown
              onSelect={(evt) => this.handleChange(evt, paymentData)}
              className="country-dropdown"
              as={ButtonGroup}
            >
              <Button variant="success">
                <span>
                  {myUtilities.accountSpecificLanguage(
                    "ACHForm.CountryCode." +
                      paymentData.getCurrentCountryCode(),
                    paymentData.getCurrentCountryCode()
                  )}
                </span>
              </Button>

              <Dropdown.Toggle
                split
                variant="success"
                id="dropdown-split-curr"
              />

              <Dropdown.Menu>
                {this.populateCountryCodeOptions(invdata, paymentData)}
              </Dropdown.Menu>
            </Dropdown>
          );
        }}
      </Subscribe>
    );
  };
  populateCountryCodeOptions = (invData, paymentData) => {
    let options = [];

    invData.state.achCountryDropdownValues.forEach((dropdown) => {
      let optionClass =
        paymentData.getCurrentCountryCode() === dropdown.value ? "clicked" : "";
      options.push(
        <Dropdown.Item
          className={optionClass}
          key={dropdown}
          eventKey={dropdown}
          
          disabled={this.props && this.props.selectedCard && this.props.selectedCard == "ACH" && ((invData.state.processorName && invData.state.processorName.toLowerCase() === "stripe") || this.props.isStripeProcessor) && dropdown && dropdown.toUpperCase() === "CA" ? true : false}
        >
          {myUtilities.accountSpecificLanguage(
            "ACHForm.CountryCode." + dropdown,
            dropdown
          )}
        </Dropdown.Item>
      );
    });

    return options;
  };
	  genDropdownAccountType = (data) => {
	    return (
	      <Dropdown
	        onSelect={(evt) => this.handleChange(evt, data)}
	        className="ach-dropdown"
	        as={ButtonGroup}
	      >
	        <Button variant="success">
	          <span>
	            {data.state.accountType === "Savings" ? 
	              myUtilities.accountSpecificLanguage("ACHForm.AccountType.Savings","Savings")
	             : 
	              myUtilities.accountSpecificLanguage("ACHForm.AccountType.Checking","Checking")
	            }
	          </span>
	        </Button>

	        <Dropdown.Toggle split variant="success" id="dropdown-split-act" />

	        <Dropdown.Menu>
	          <Dropdown.Item
	            eventKey="Savings"
	            className={data.state.accountType === "Savings" ? "clicked" : ""}
	          >
	            {myUtilities.accountSpecificLanguage("ACHForm.AccountType.Savings","Savings")}
	          </Dropdown.Item>
	          <Dropdown.Item
	            className={data.state.accountType === "Checking" ? "clicked" : ""}
	            eventKey="Checking"
	          >
	            {myUtilities.accountSpecificLanguage("ACHForm.AccountType.Checking","Checking")}
	          </Dropdown.Item>
	        </Dropdown.Menu>
	      </Dropdown>
	    );
	  };
  showDropDown = (elementType, data) => {
    if (this.props.isEIPPDropdown && this.props.isMandateField) {
      if (elementType.localeCompare("header") == 0) {
        return (
          <Col className="payment-element-header payment-element-header2">
            {this.decideDropDownToShow(data)}
          </Col>
        );
      }
      return;
    }

    if (this.props.header2) {
      if (elementType.localeCompare("header") == 0) {
        return (
          <Col className="payment-element-header payment-element-header2">
            {this.props.header2}
          </Col>
        );
      } else if (elementType.localeCompare("value") == 0) {
        return (
          <Col className="payment-element-value">
            {this.decideDropDownToShow(data)}
          </Col>
        );
      }
    }
  };

  setPaymentDataToState = (data) => {
    console.log("setting data to payment data in class -> ", data);
    this.paymentData = data;
    return null;
  };

  render() {
    return (
      <Subscribe to={[PaymentDataContainer]}>
        {(data) => (
          <Col>
            <Container className="payment-element-container">
              <Row>
                <Col className="payment-element-header">
                  {this.props.header}
                </Col>
                {this.showDropDown("header", data)}
              </Row>
              <Row>
                <Col className="payment-element-value">
                  {this.renderBody()}
                </Col>
                {this.showDropDown("value", data)}
              </Row>
            </Container>
            {/* setting data to state */}
            {this.setPaymentDataToState(data)}
          </Col>
        )}
      </Subscribe>
	  );
  }

  // Called only once when component is loaded to the UI
  componentDidMount() {
    if (this.props.isMandateField && this.props.isEIPPDropdown && !this.state.isDropdownStoreLoaded) {
      this.populateEIPPDropdownItems();
    }
  }

  // Called when state changes
  componentDidUpdate(prevProps, prevState) {
    if (this.state.currentValueInEIPPDropdown != prevState.currentValueInEIPPDropdown && prevState.currentValueInEIPPDropdown == "") {
      console.log("componentDidUpdate prevState -> " + prevState.currentValueInEIPPDropdown);
      console.log("componentDidUpdate current state -> currentValueInEIPPDropdown -> " + this.state.currentValueInEIPPDropdown);
      let val = this.state.currentValueInEIPPDropdown;
      
      console.log("val before change -> " + val);
      let value = this.displayNameVsValueMap[val];
      console.log("val after change -> " + value);

      if (this.paymentData != null) {
        console.log("value in this.paymentData -> " + this.paymentData);
        let achMandateFields = this.paymentData.state.achMandateFields;
        
        if (this.props.isMandateField) {
          console.log("value in achMandateField -> " + value);
          if (value.length > 0 && null != achMandateFields) {
            achMandateFields[this.props.name] = value;
            this.paymentData.setACHMandateFields(achMandateFields);
          } else if (value.length > 0 && null == achMandateFields) {
            achMandateFields = {};
            achMandateFields[this.props.name] = value;
            this.paymentData.setACHMandateFields(achMandateFields);
          }
        }
      }
    }
  }
}

export default PaymentElements;
